import React, { Component } from 'react';
import combinate from 'combinate';
import _ from 'lodash';

import TitleReload from '../../common/TitleReload';

export default class MediumAddition3 extends Component {
  state = {
    numbers: [],
  };

  componentDidMount() {
    this.handleReload();
  }

  getNumber = (number, index = 0) => {
    return _.toNumber(_.split(number, '')[index]);
  };

  handleReload = () => {
    const numbers = _.chain(
      combinate({
        num: _.range(11, 100),
        den: _.range(11, 100),
      }).filter(og => {
        const numFirst = this.getNumber(og.num);
        const denFirst = this.getNumber(og.den);

        const numLast = this.getNumber(og.num, 1);
        const denLast = this.getNumber(og.den, 1);

        return numFirst + denFirst >= 10 && numLast + denLast >= 10;
      }),
    )
      .shuffle()
      .take(50)
      .value();

    this.setState({ numbers });
  };

  render() {
    const { numbers } = this.state;
    return (
      <React.Fragment>
        <TitleReload title="Medium Addition #3" handleReload={this.handleReload} />
        <div className="flex flex-wrap gap-4 pt-5 text-lg md:text-2xl">
          {numbers.length &&
            numbers.map(number => {
              return (
                <div key={`${number.num}${number.den}`}>
                  <div className="flex flex-col">
                    <div className="px-5 bg-yellow-100 text-right">&nbsp;{`${number.num}`}</div>
                    <div className="px-5 bg-red-100">+{`${number.den}`}</div>
                  </div>
                </div>
              );
            })}
        </div>
      </React.Fragment>
    );
  }
}
